<template>
    <div>
        <vs-row  class="form"> 
            <p>Es importante mencionar que es responsabilidad del receptor indicar sus datos fiscales tal y como se encuentran en su constancia de situación fiscal más actual, respetando mayúsculas y caracteres.</p>
            <vs-col sm="12" lg="4" class="my-3">
                <div>
                    <label class="Tarjetahabiente" for="rfc">RFC</label> <i class="fas fa-shield-alt"></i>
                    <input @input="eliminarCaracteres(rfc, 'rfc')" type="text" name="name" pattern="[^()/><\][\\\x22,;|]+" id="rfc"  v-model="rfc" autocomplete="off" maxlength="13" required>
                    <p v-if="rfcCaracteres" class="mb-0" style="color: red;"><small>RFC contiene caracteres no permitidos</small></p>
                </div>
            </vs-col>
            <vs-col sm="12" lg="4" class="my-3">
                <div>
                    <label class="Tarjetahabiente" for="razon">Razón social</label> <i class="fas fa-shield-alt"></i>
                    <input type="text" @input="eliminarCaracteres(razon, 'razon')" name="name" id="razon" v-model="razon" placeholder="Razón social" autocomplete="off">
                </div>
            </vs-col>
            <vs-col sm="12" lg="4" class="my-3">
                <div>
                    <label class="Tarjetahabiente" for="correo">Correo fiscal</label> <i class="fas fa-shield-alt"></i>
                    <input type="text" name="name" id="correo" v-model="correo" placeholder="Correo fiscal" autocomplete="off">
                </div>
            </vs-col>
            <vs-col sm="12" lg="4" class="my-3">
                <div>
                    <label class="Tarjetahabiente" for="correo">Régimen Fiscal</label> <i class="fas fa-shield-alt"></i>
                    <select class="selectOption" v-model="regimen" id="banco">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="option in regimenes" :key="option.id" :label="option.text" :value="option.id">{{option.text}}</option>
                    </select>
                </div>
            </vs-col>
            <vs-col sm="12" lg="4" class="my-3">
                <div>
                    <label class="Tarjetahabiente" for="correo">C.P.</label> <i class="fas fa-shield-alt"></i>
                    <input type="number" name="name" id="correo" v-model="cp" placeholder="C.P." autocomplete="off">
                </div>
            </vs-col>
            <vs-col sm="12" lg="4" class="my-3">
                <label class="Tarjetahabiente" for="banco">Uso de CFDI</label> <i class="fas fa-shield-alt"></i>
                <select class="selectOption" v-model="cfdi" id="banco">
                    <option value="" disabled selected>Seleccione una opción</option>
                    <option v-for="option in optCfdi" :key="option.id" :label="option.text" :value="option.id">{{option.text}}</option>
                </select>
            </vs-col>
            <vs-col sm="12" lg="4" class="my-3">
                <label class="Tarjetahabiente" for="banco">Facturación automática</label>
                <select class="selectOption" v-model="facturacion" id="banco">
                    <option value="" disabled selected>Seleccione una opción</option>
                    <option label="Si" value="1" selected>Si</option>
                    <option label="No" value="0">No</option>
                </select>
            </vs-col>
            <vs-col sm="12" lg="6" class="ml-auto mt-3 d-flex" style="justify-content: flex-end">
                <vs-button
                    style="background:#C0392B"
                    square
                    :disabled="confirmadoEliminar"
                    @click="postEliminarDatosFiscales()"
                >
                    Borrar datos
                </vs-button>
                <vs-button
                    square
                    :disabled="confirmado"
                    @click="postGuardarDatosFiscales()"
                >
                    Guardar
                </vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import landing from '../../../../api/requests/landing'
export default {
    props:[
        'personaId'
    ],
    data(){
        return{
            rfc: '',
            razon: '',
            correo: '',
            cfdi: '',
            facturacion: 1,
            optCfdi:[
                {'id': 'G01', 'text': 'Adquisición de Mercancías'},
                {'id': 'G02', 'text': 'Devoluciones, Descuentos o Bonificaciones'},
                {'id': 'G03', 'text': 'Gastos en General'},
                {'id': 'I01', 'text': 'Construcciones'},
                {'id': 'I02', 'text': 'Mobiliario y Equipo de Oficina por Inversiones'},
                {'id': 'I03', 'text': 'Equipo de Transporte'},
                {'id': 'I04', 'text': 'Equipo de Cómputo y Accesorios'},
                {'id': 'I05', 'text': 'Dados, Troqueles, Moldes, Matrices y Herramental'},
                {'id': 'I06', 'text': 'Comunicaciones Telefónicas'},
                {'id': 'I07', 'text': 'Comunicaciones Satelitales'},
                {'id': 'I08', 'text': 'Otra Maquinaria y Equipo'},
                {'id': 'D01', 'text': 'Honorarios Médicos, Dentales y Gastos Hospitalarios'},
                {'id': 'D02', 'text': 'Gastos Médicos por Incapacidad o Discapacidad'},
                {'id': 'D03', 'text': 'Gastos Funerales'},
                {'id': 'D04', 'text': 'Donativos'},
                {'id': 'D05', 'text': 'Intereses Reales Efectivamente Pagados por Créditos Hipotecarios (Casa Habitación)'},
                {'id': 'D06', 'text': 'Aportaciones Voluntarias al SAR'},
                {'id': 'D07', 'text': 'Primas por Seguros de Gastos Médicos'},
                {'id': 'D08', 'text': 'Gastos de Transportación Escolar Obligatoria'},
                {'id': 'D09', 'text': 'Depósitos en Cuentas para el Ahorro, Primas que tengan como Base Planes de Pensiones'},
                {'id': 'D10', 'text': 'Pagos por Servicios Educativos (Colegiaturas)'},
                {'id': 'P01', 'text': 'Por Definir'}
            ],
            cp: '',
            regimenes: [],
            regimen: '',
            info: [],
            confirmado: false,
            confirmadoEliminar: false,
            rfcCaracteres: false
        }
    },
    created(){
        this.getDatosFiscales()
        this.getRegimen()
    },
    methods:{
        eliminarCaracteres(info, tipo){
            console.log(tipo)
            info = info
                .normalize('NFD')
                .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1")
                .normalize();
            if(tipo == 'rfc'){
                this.rfc = info.toUpperCase()
            }else{
                this.razon = info.toUpperCase()
            }
        },
        async getDatosFiscales() {
            try {
                const response = await landing.getDatosFiscales(this.personaId)
                if(response.data.datos_fiscales.correo_fiscal || response.data.datos_fiscales.rfc){
                    this.info = response.data.datos_fiscales
                    this.confirmadoEliminar = false
                }else{
                    this.rfc = ''
                    this.razon = ''
                    this.correo = ''
                    this.cfdi = ''
                    this.facturacion = 1
                    this.confirmadoEliminar = true
                }
            } catch (error) {

            }
        },
        async getRegimen(){
            try {
                const response = await landing.getRegimen(this.personaId)
                this.regimenes = response.data
            } catch (error) {

            }
        },
        getinfo(){
            this.rfc = this.info.rfc
            this.razon = this.info.razon_social
            this.correo = this.info.correo_fiscal
            this.cfdi = this.info.uso_cfdi
            this.facturacion = this.info.facturacion_automatica
            this.cp = this.info.codigo_postal
            this.regimen = this.info.regimen_fiscal
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('string', this.rfc)) {
                this.errorFields.push('rfc')
            }
            if (!this.checkByType ('string', this.razon)) {
                this.errorFields.push('razon')
            }
            if (!this.checkByType ('string', this.correo)) {
                this.errorFields.push('correo')
            }
            if (!this.regimen) {
                this.errorFields.push('regimen')
            }
            if (!this.cp) {
                this.errorFields.push('cp')
            }
            if (!this.cfdi) {
                this.errorFields.push('cfdi')
            }
            if (!this.errorFields.length){
                const formData = new FormData()
                const rfc = this.rfc.toUpperCase()
                formData.append('tipo', 'alumno')
                formData.append('rfc', rfc)
                formData.append('razon_social', this.razon)
                formData.append('correo_fiscal', this.correo)
                formData.append('uso_cfdi', this.cfdi)
                formData.append('codigo_postal', this.cp)
                formData.append('regimen_fiscal', this.regimen)
                if(this.facturacion == '1'){
                    formData.append('facturacion_automatica', 'on')
                }
                return formData
            } else {
                const error = 'si'
                return error
            }
        },
        async postGuardarDatosFiscales(){
            try {
                var cadena = this.rfc
                var carecter = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(cadena);
                if(carecter == true){
                    this.rfcCaracteres = true
                    return
                }else{
                    const info = this.sanityForm()
                    this.rfcCaracteres = false
                    if(info != 'si'){
                        this.confirmado = true
                        this.confirmadoEliminar = true
                        const response = await landing.postGuardarDatosFiscales(info, this.personaId)
                        this.confirmado = false
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            title: 'Información guardada',
                            text: 'La información se ha guardado con éxito'
                        })
                        this.getDatosFiscales()
                    } else if(info == 'si'){
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            title: 'Información incompleta',
                            text: 'Es necesario la información obligatoria.'
                        })
                    }
                }   
            } catch (error) {
                this.confirmado = false

            }
        },
        async postEliminarDatosFiscales(){
            try {
                this.confirmado = true
                this.confirmadoEliminar = true
                const response = await landing.postEliminarDatosFiscales(this.info.id)
                if(!response.datos_fiscales){
                    this.regimen = ''
                    this.cp = ''
                }
                this.confirmado = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    title: 'Información eliminada',
                    text: 'La información asociada se elimino con éxito'
                })
                this.getDatosFiscales()
            } catch (error) {
                this.confirmado = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    title: 'Algo salio mal',
                    text: 'Favor de contactar al administrador'
                })
            }
        },
    },
    watch:{
        info() {
            this.getinfo()
        },
        personaId(){
            this.getDatosFiscales()
        }
    }
}
</script>
<style>
    .form .selectOption, input[type="text"], input[type="number"]{
        width: 95%;
        padding: 0.375rem 0.75rem;
        height: calc(1.6em + 0.75rem + 2px);
        font-size: 0.9rem;
        color: #495057;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
    }
    .form select:focus {
        outline: none;
        border-color: #2c3e50;
        box-shadow: 0 0 5px rgba(44, 151, 222, 0.2);
    }

    .form input[type="submit"] {
        border: none;
        background: #448aff;
        border-radius: 0.25em;
        padding: 5px 10px;
        color: #ffffff;
        font-weight: bold;
        float: right;
        cursor: pointer;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        appearance: none;
    }

    .addOther {
        border: none;
        background: #27AE60;
        border-radius: 0.25em;
        padding: 0;
        color: #ffffff !important;
        font-weight: bold;
        float: right;
        cursor: pointer;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        appearance: none;
        }

        .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>